import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import DomainTagList from "./DomainTagList";
import { BrandgenPublicationList } from "../../../../types/campaignTypes";

type SetListDomainsProps = {
  lists: BrandgenPublicationList[];
};

const Groups = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  padding: "10px 0 12px",
});

const GroupHeader = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "0 16px",
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.brand.gray700,
}));

const DomainCount = styled("span")(({ theme }: { theme: Theme }) => ({
  fontWeight: 400,
  color: theme.palette.brand.gray500,
}));

const EmptyLabel = styled("div")(({ theme }: { theme: Theme }) => ({
  padding: "10px 16px",
  fontSize: 12,
  color: theme.palette.brand.gray400,
}));

/**
 * Contents of an expanded set row: every member list's name followed by its own
 * active domains. Shared by the Sets tab and the campaign builder's set picker.
 */
const SetListDomains: FC<SetListDomainsProps> = ({ lists }) => {
  if (lists.length === 0) {
    return <EmptyLabel>No publication lists in this set.</EmptyLabel>;
  }

  return (
    <Groups>
      {lists.map((list) => {
        const activeCount = list.listDomains?.filter((domain) => domain.active).length ?? 0;
        return (
          <div key={list.id}>
            <GroupHeader>
              {list.name}
              <DomainCount>{activeCount.toLocaleString()}</DomainCount>
            </GroupHeader>
            <DomainTagList domains={list.listDomains ?? []} />
          </div>
        );
      })}
    </Groups>
  );
};

export default SetListDomains;
